import React, { createContext, useContext, useMemo } from "react";
import * as Option from "@utils/Option";
import type { OptionTs } from "@ps-bridge/interop";
import type { AdminUserClient } from "@ps-bridge/clients/adminUsers";
import { createDefaultAdminUserClient, createStubAdminUserClient } from "@src/purescript/interop";
import { enabledFeatures, FeaturesEnum } from "@utils/enabledFeatures";
import { requireContext } from "@contexts/requireContext";

const AdminUserClientContext = createContext<OptionTs<AdminUserClient>>(Option.none());

export const AdminUserClientProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const adminUserClient = useMemo<AdminUserClient>(() => {
    if (enabledFeatures[FeaturesEnum.StubClients]) {
      return createStubAdminUserClient;
    }
    return createDefaultAdminUserClient;
  }, []);

  const contextValue = useMemo(() => Option.some(adminUserClient), [adminUserClient]);

  return (
    <AdminUserClientContext.Provider value={contextValue}>
      {children}
    </AdminUserClientContext.Provider>
  );
};

export const useAdminUserClient = (): AdminUserClient => {
  return requireContext(
    useContext(AdminUserClientContext),
    "useAdminUserClient must be used within an AdminUserClientProvider",
  );
};
